module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.url,
      "alt": "a playing card",
      "id": 'card' + _vm.index
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler(_vm.index)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cardTitle"
  }, [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3467d6bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = 196
// module chunks = 0